import React from "react";
import ResetPasswordForm from "../../../containers/user-management/ResetPasswordForm/ResetPasswordForm";
import { Wrapper, Container, Content, EntryCol, ContentCol, Logo, SubLogoTitle } from '../styles';

const ResetPasswordPage = () => {
  return (
    <Wrapper>
      <Container>
        <Content>
            <EntryCol>
              <Logo>Offolio</Logo>
              <SubLogoTitle>Login to access your account</SubLogoTitle>
            </EntryCol>
            <ContentCol>
              <ResetPasswordForm />
            </ContentCol>
        </Content>
      </Container>
    </Wrapper>
  );
};

export default ResetPasswordPage;
